<template>
    <div>
        <section class="layout layout-scale overflow-hidden no-footer">
            <div class="header">
                <div class="flex justify-between items-center">
                    <HeaderLogo
                        :warning-message="$t('playalone_alert_leave')"
                        :logo-width="9.25"
                        :mobile-logo-width="9"
                        :embed="embedToken"
                        :url="quiz.url"
                        color="var(--ui-color)"
                        shadow="var(--question-shadow-color)"
                        class="inline-block logo"
                    ></HeaderLogo>
                    <a
                        @click="goFrontPage()"
                        :href="landingPageUrl"
                        class="title-header text-left sm:text-center font-bold font-size-20 sm:font-size-38 text-white my-2 w-5/6 truncate"
                    >
                        {{ title }}
                    </a>
                    <!-- <p class="text-2xl md:text-4xl text-right font-garage text-white pr-4 pt-0 md:pt-4 font-bold">{{ questionCount }} Questions</p> -->
                </div>
            </div>
            <div
                :class="{ 'animated fadeIn': isAlreadyShow, 'opacity-0': !isAlreadyShow }"
                class="content with-scroll relative mx-0"
            >
                <div id="summary_container" class="lg:flex flex-col content-container">
                    <div class="sm:flex lg:justify-between w-full max-w-xl mx-auto py-5">
                        <div class="sm:w-1/2 xl:w-1/3">
                            <div
                                class="w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 xs:w-full border-style bg-item bg-cover bg-center bg-norepeat mx-auto"
                                :style="`background-image: url(${getQuizImage(quiz, true)});`"
                            ></div>
                            <div class="text-center title-box">
                                <h1
                                    v-html="title"
                                    class="theme-question-text-color theme-question-shadow text-center font-bold font-size-24 sm:font-size-38 mb-2"
                                ></h1>
                                <p
                                    v-if="description"
                                    class="text-md theme-question-text-color font-size-18 read-plaintext-only hidden lg:block quiz-description"
                                >
                                    <span v-html="description" class="theme-question-shadow"></span>
                                </p>
                                <div class="mb-6"></div>
                            </div>
                        </div>
                        <div class="theme-ui-text-color sm:w-1/2 xl:w-1/3 text-center" style="min-height: 36rem">
                            <p class="theme-question-shadow uppercase font-size-24 sm:font-size-30">
                                {{ $t('playalone_summary_header') }}
                            </p>
                            <ChartRadial
                                :percent="percent"
                                :show-animate="isAnimateAfterCoinEnd"
                                ring-color="var(--ui-color-alpha-50)"
                                color="var(--ui-color)"
                                stroke-width="4.5"
                                id="chart-your-result"
                                size="120px"
                            />
                            <div class="flex justify-center mb-6 sm:mb-3">
                                <div class="w-1/3">
                                    <p class="theme-question-shadow font-size-18 font-light uppercase">
                                        {{ $t('playalone_summary_header_correct') }}
                                    </p>
                                    <p class="theme-question-shadow font-size-32 sm:font-size-38 font-bold uppercase">
                                        {{ correct }}
                                    </p>
                                </div>
                                <div class="w-1/3">
                                    <p class="theme-question-shadow font-size-18 font-light uppercase">
                                        {{ $t('playalone_summary_header_time') }}
                                    </p>
                                    <p class="theme-question-shadow font-size-32 sm:font-size-38 font-bold uppercase">
                                        {{ time }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="quiz.is_sponsor_quiz && !embedToken" @click="onClickJoinCompetition">
                                <JoinCompetition
                                    :logged-in="isLoggedIn()"
                                    :show-animate="isRewardAnimation"
                                    class="mb-8 sm:mb-5"
                                    ref="competition"
                                ></JoinCompetition>
                            </div>
                            <YouVsTheWorld
                                v-if="isFrontPageQuiz"
                                @login="embedToken ? goDefaultPage() : youVsWorldLogin()"
                                :percent="percent > 0 ? avgScore : 0"
                                :is-login="isLoggedIn()"
                                :show-animate="isAnimateAfterCoinEnd"
                                id="you-vs-the-world"
                            />
                            <div class="pt-3 mb-5">
                                <div
                                    v-if="isLoggedIn()"
                                    class="font-size-18 cursor-pointer progress-btn mb-2"
                                    @click="onShowDidYouLearn"
                                >
                                    {{ $t('playalone_summary_learn') }}
                                </div>
                                <div
                                    v-if="isLoggedIn()"
                                    class="font-size-18 cursor-pointer progress-btn mb-2"
                                    @click="onShowYourProgress"
                                >
                                    {{ $t('playalone_summary_progress') }}
                                </div>
                                <div class="font-size-18 cursor-pointer progress-btn" @click="restartAgain">
                                    {{ $t('playalone_summary_again') }}
                                </div>
                            </div>
                            <div class="w-full flex justify-center items-center mt-5">
                                <div class="dropdown dropup btn-group text-center mr-1">
                                    <div :class="{ 'dropdown-menu font-size-22': true, show: shareListOpen }">
                                        <a
                                            :href="shareFacebookUrl.trim()"
                                            class="theme-button dropdown-item no-underline"
                                            target="_blank"
                                        >
                                            <i class="theme-question-shadow fab fa-facebook"></i>
                                            <span class="w-full pl-3" style="text-shadow: unset">facebook</span>
                                        </a>
                                        <a
                                            :href="shareTwitterUrl.trim()"
                                            class="theme-button dropdown-item no-underline"
                                            target="_blank"
                                        >
                                            <i class="theme-question-shadow fab fa-twitter"></i>
                                            <span class="w-full pl-3" style="text-shadow: unset">twitter</span>
                                        </a>
                                        <div class="theme-button dropdown-item no-underline" @click="copyShareLink">
                                            <i class="theme-question-shadow fas fa-external-link-alt"></i>
                                            <span class="w-full pl-3" style="text-shadow: unset">{{
                                                $t('playalone_summary_button_share')
                                            }}</span>
                                        </div>
                                    </div>
                                    <div
                                        @click="openShare"
                                        class="theme-button btn btn-large font-size-18 md:font-size-22 font-bold font-opensans uppercase"
                                    >
                                        <i class="fas fa-share-alt" style="text-shadow: unset"></i>
                                    </div>
                                </div>
                                <div class="text-center mx-1" style="width: max-content">
                                    <a
                                        v-if="!embedToken || (embedToken && isFrontPageQuiz)"
                                        @click="goDefaultPage('play-live-btn')"
                                        :href="`${baseUrl}play/${quizId}/together`"
                                        class="theme-button play-live-btn btn w-full font-size-18 md:font-size-22 font-normal font-opensans uppercase shadow-text-none"
                                    >
                                        {{ $t('playalone_summary_live') }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="quizRelate.length > 0"
                    :class="{ 'relate text-center w-full mb-5': true, open: quizRelate.length > 0 }"
                    id="quiz-relate"
                >
                    <h3 class="theme-question-text-color theme-question-shadow text-white font-size-22">
                        {{ $t('playalone_summary_header_try') }}
                    </h3>
                    <div id="quiz-relate-list" class="flex flex-wrap justify-center">
                        <div
                            v-for="(quiz, index) in quizRelate"
                            :key="index"
                            class="w-1/2 sm:w-1/3 lg:w-1/4 xl:w-1/5 mb-2 sm:mb-4 xl:mb-8 animated zoomIn"
                        >
                            <AnotherQuiz
                                @click="onClickQuiz"
                                :use-emit-click="true"
                                :id="quiz._id.$oid"
                                :title="quiz.title"
                                :image="quiz.image"
                                :url="quiz.url"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <transition name="fade">
                <ArrowDownAnimation v-if="isArrowRelate" @click.native="scrollToBottom" />
            </transition>
        </section>

        <div>
            <TopRightMenu
                @click-your-quiz-link="clickToMyQuiz()"
                @click-new-quiz="clickNewQuiz()"
                @click-edit-profile="clickEditProfile()"
                @click-order="clickOrder()"
                @click-subscribe-plan="clickSubscribePlan()"
                @click-subpage="clickSubpage"
                @click-buy-credit="clickBuyCredit()"
                @click-logout="clickLogout"
                @click-with-embed="goFrontPage"
                @open-auth-popup="
                    joinMenu = false
                    showAuthPopup = true
                "
                :login-status="loginStatus"
                :embed="embedToken"
                class="summary-right-menu"
            />
            <AuthPopup
                v-if="showAuthPopup && !embedToken"
                @login-success="loginSuccess"
                @register-success="loginSuccess"
                @sponsor-quiz-track="saveSponsorQuizTrack"
                @send-contact="updateUserInfoInRanking"
                @close="
                    showAuthPopup = false
                    isSeePosition = false
                "
                :webview-redirect-to="createWebviewRedirectTo()"
                :show-third-party-in-webview="false"
                :sponsor-quiz="quiz"
                :is-muted="isMuted"
                :join-menu="joinMenu"
                :is-see-position="isSeePosition"
                :share-link-url="shareLinkUrl"
                ref="authPopup"
            />
        </div>

        <CoinContainer v-if="isShowCoinContainer" :totalCoin="totalCoin" @ended="onCoinAnimateEnded" />

        <PaymentPopup
            v-if="showPaymentPopup"
            @success="paymentSuccess"
            @close="showPaymentPopup = false"
            :payment-title="$t('purchase_header_upgrade')"
            :quiz-id="quizId"
        />

        <!-- Did you learn modal -->
        <ResultLayoutPopup v-if="showDidyouLearnPopup" @close="showDidyouLearnPopup = false">
            <div
                v-if="wrongQuestions && wrongQuestions.length"
                class="flex flex-col items-center justify-center shadow-text-none h-full"
            >
                <h3 class="font-size-26 lg:font-size-30 mb-5 mt-0">{{ $t('result_modal_header_learn') }}</h3>
                <p class="font-size-20 lg:font-size-24 text-center mb-5">{{ $t('result_modal_description') }}</p>
                <div
                    @click="playAgain"
                    class="btn padding-sm font-size-20 lg:font-size-24 font-opensans system-button-color system-button-text-color"
                >
                    {{ $t('result_modal_button_start') }}
                </div>
            </div>
            <div v-else class="flex flex-col items-center justify-center shadow-text-none h-full">
                <p class="text-6xl">🎉</p>
                <h3 class="font-size-26 lg:font-size-30 mb-5 mt-0">{{ $t('result_modal_header_hooray') }}</h3>
                <p class="font-size-20 lg:font-size-24 text-center mb-5">{{ $t('result_modal_hooray_desciption') }}</p>
                <div
                    @click="closeDidYouLearn"
                    class="btn padding-sm font-size-18 lg:font-size-24 font-opensans system-button-color system-button-text-color"
                >
                    {{ $t('result_modal_button_close') }}
                </div>
            </div>
        </ResultLayoutPopup>

        <!-- Your score modal -->
        <ResultLayoutPopup v-if="showYourProgressPopup" @close="showYourProgressPopup = false">
            <div class="flex flex-col items-center justify-center shadow-text-none h-full">
                <h3 class="font-size-24 lg:font-size-30 mb-4 mt-0">{{ $t('result_modal_header_progress') }}</h3>
                <div class="shadow-text-none mb-3 text-center">
                    <ChartRadial
                        id="chart-progress-main"
                        :is-animate-on-mount="true"
                        :percent="overAllScore"
                        :is-show-arrow-up="overAllIsUp"
                        :is-show-arrow-down="!overAllIsUp"
                        ring-color="rgba(0,0,0,0.5)"
                        stroke-width="4.5"
                        color="#000"
                        size="110px"
                    />
                    <p class="font-size-20">{{ $t('result_modal_overall') }}</p>
                </div>
                <div class="flex flex-wrap justify-center text-center w-full">
                    <template v-for="(progress, progressIndex) in yourProgress">
                        <div
                            @click="onSelectImprove(progress)"
                            :key="`progress-${progressIndex}`"
                            class="w-1/2 shadow-text-none mb-3 cursor-pointer"
                        >
                            <ChartRadial
                                :id="`chart-progress-${progressIndex}`"
                                :percent="progress.percent"
                                :is-animate-on-mount="true"
                                :is-show-arrow-up="progress.isUp"
                                :is-show-arrow-down="progress.isDown"
                                ring-color="rgba(0,0,0,0.5)"
                                stroke-width="4.5"
                                color="#000"
                                size="110px"
                            />
                            <p class="font-size-20">{{ progress.title }}</p>
                            <p class="font-size-16">{{ $t('result_modal_improve_score') }}</p>
                        </div>
                    </template>
                </div>
            </div>
        </ResultLayoutPopup>

        <!-- Improve modal -->
        <ResultLayoutPopup v-if="showImprovePopup && improveSelected" @close="showImprovePopup = false">
            <div class="flex flex-col items-center justify-center shadow-text-none h-full">
                <h3 class="font-size-26 lg:font-size-30 mb-5 mt-0">{{ $t('result_modal_header_improve') }}</h3>
                <ChartRadial
                    :id="`chart-imporve-${improveSelected.title.trim().toLowerCase().replace(/ /g, '-')}`"
                    :percent="improveSelected.percent"
                    :is-animate-on-mount="true"
                    :is-show-arrow-up="improveSelected.isUp"
                    :is-show-arrow-down="improveSelected.isDown"
                    ring-color="rgba(0,0,0,0.5)"
                    stroke-width="4.5"
                    color="#000"
                    size="110px"
                />
                <p class="font-size-24">{{ improveSelected.title }}</p>
                <p class="font-size-18 text-center mb-8">
                    {{
                        improveSelected.isUp
                            ? $t('result_modal_improve_description_up')
                            : $t('result_modal_improve_description_down')
                    }}
                </p>
                <div>
                    <div
                        class="w-full btn padding-sm font-size-20 lg:font-size-24 font-opensans mb-4 system-button-color system-button-text-color"
                        @click="onClickRandomQuiz(improveSelected.title)"
                    >
                        {{ $t('result_modal_button_random') }}
                    </div>
                    <div
                        class="w-full btn padding-sm font-size-20 lg:font-size-24 font-opensans system-button-color system-button-text-color"
                        @click="onClickSpecific(improveSelected.title)"
                    >
                        {{ $t('result_modal_button_specific') }}
                    </div>
                </div>
            </div>
        </ResultLayoutPopup>
    </div>
</template>

<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
import { mapState, mapGetters } from 'vuex'
import helper from '@/lib/helper.js'
import Request from '@/lib/request.js'
import appConfig from '@/app.config.js'
import popup from '@/lib/popup.js'
import ResizeScale from '@/lib/resize-scale.js'
import preloadSongMixin from '@/mixins/preload-song'
import TopRightMenu from '@/components/TopRightMenu'
import AuthPopup from '@/components/AuthPopup'
import AnotherQuiz from '@/components/AnotherQuiz.vue'
import AuthPopupMixin from '@/mixins/auth-popup'
import CoinContainer from '@/components/CoinContainer'
import { isLoggedIn, currentUser } from '@/lib/user.js'
import PaymentPopup from '@/components/PaymentPopup'
import ChartRadial from '@/components/playalone/ChartRadial'
import YouVsTheWorld from '@/components/playalone/YouVsTheWorld'
import ResultLayoutPopup from '@/components/playalone/ResultLayoutPopup'
import JoinCompetition from '@/components/JoinCompetition'
import Cookies from 'js-cookie'
import ArrowDownAnimation from '@/components/ArrowDownAnimation.vue'
import crypto from '@/lib/crypto.js'
import helperMixins from '@/mixins/helper.js'

export default {
    metaInfo() {
        return {
            link: [
                {
                    rel: 'stylesheet',
                    href: `${process.env.VUE_APP_ROOT_URL}style/dynamic/quiz/${
                        this.code
                    }.css?rand=${new Date().getTime()}`,
                    type: 'text/css'
                }
            ]
        }
    },

    components: {
        HeaderLogo,
        TopRightMenu,
        AuthPopup,
        CoinContainer,
        ChartRadial,
        YouVsTheWorld,
        PaymentPopup,
        ResultLayoutPopup,
        AnotherQuiz,
        JoinCompetition,
        ArrowDownAnimation
    },

    mixins: [preloadSongMixin, AuthPopupMixin, helperMixins],

    computed: {
        ...mapGetters({
            quizRelate: 'getRelateQuiz',
            questionCount: 'player/getQuestionCount',
            totalCoin: 'player/totalCoin',
            wrongQuestions: 'player/wrongQuestions',
            isFromMyQuiz: 'player/isFromMyQuiz',
            playAloneReportToken: 'player/playAloneReportToken'
        }),

        ...mapState({
            quizId: state => state.player.quiz._id.$oid,
            quiz: state => state.player.quiz,
            name: state => state.player.name,
            questions: state => state.player.quiz.questions,
            title: state => state.player.quiz.title,
            type: state => state.player.quiz.type,
            code: state => state.player.quiz.code,
            image: state => state.player.quiz.image,
            description: state => state.player.quiz.description,
            userSelected: state => state.player.userSelected,
            orderAbility: state => state.orderAbility,
            tags: state => state.player.quiz.tags,
            isMuted: state => state.isMuted,
            embedToken: state => state.player.embedToken,
            isFrontPageQuiz: state => state.player.isFrontPageQuiz
        }),

        shareFacebookUrl() {
            var payload = {
                score: this.percent,
                quiz: this.quizId
            }

            return `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(
                `${appConfig.baseUrl}user/share/quiz?data=${btoa(JSON.stringify(payload))}`
            )}`
        },

        shareTwitterUrl() {
            var payload = {
                score: this.percent,
                quiz: this.quizId
            }

            return `http://twitter.com/share?text=&url=${encodeURI(
                `${appConfig.baseUrl}user/share/quiz?data=${btoa(JSON.stringify(payload))}`
            )}`
        },

        landingPageUrl() {
            if (this.isFromMyQuiz) {
                return `${this.quiz.url}?ref=myquiz`
            }

            return `${this.quiz.url}`
        }
    },

    data() {
        return {
            baseUrl: appConfig.baseUrl,
            percent: -1,
            correct: '1/1',
            time: '0:00',
            timeSec: 0,
            avgScore: 0,
            amongTo: 0,
            // quizRelate: [],
            isAlreadyShow: false,
            isShowCoinContainer: false,
            shareListOpen: false,
            currentUser: null,
            currentUserId: '',
            showPaymentPopup: false,
            showDidyouLearnPopup: false,
            showYourProgressPopup: false,
            isAnimateAfterCoinEnd: false,
            isRewardAnimation: false,
            showImprovePopup: false,

            yourProgress: [],
            overAllScore: 0,
            overAllIsUp: true,
            improveSelected: null,
            joinMenu: false,
            isSeePosition: false,
            shareLinkUrl: '',
            isArrowRelate: false
        }
    },

    created() {
        if (
            this.quiz.background_image !== '' &&
            this.quiz.background_image !== null &&
            this.quiz.background_type !== ''
        ) {
            document.getElementsByTagName('BODY')[0].classList.add('has-bg-image')
        }
    },

    mounted() {
        this.getResult()
        this.setConfirmLeavePage()
        this.showCoinAnimation()
        this.saveSponsorQuizScore()
        this.saveForReport()

        if (isLoggedIn()) {
            this.currentUser = currentUser()
            this.currentUserId = currentUser().id

            if (Object.keys(this.orderAbility).length === 0) {
                this.findOrderAbility()
            }

            if (this.totalCoin > 0) {
                this.$store.dispatch('saveCoin', this.totalCoin).then(() => {
                    this.$store.dispatch('getCredit')
                })
            }
        }

        helper.gTrackEvent('play', {
            event_category: 'PlayAlone',
            event_label: `EndPlay_${this.code}_single`
        })

        window.addEventListener('resize', this.resizeScaleQuizFrame())

        this.$nextTick(() => {
            this.quizRelateInViewport()
        })
    },

    destroyed() {
        this.hideConfirmLeavePage()
        document.getElementsByTagName('BODY')[0].classList.remove('has-bg-image')
    },

    watch: {
        loginStatus(status) {
            if (status) {
                this.currentUser = currentUser()
                this.findOrderAbility()
            }
        },

        isAnimateAfterCoinEnd() {
            this.showSponsorPopup()
        }
    },

    methods: {
        afterLoginSuccess() {
            this.getResult()
            this.setConfirmLeavePage()
            this.showCoinAnimation()
            if (this.quiz.is_sponsor_quiz) {
                this.saveSponsorQuizScore().then(() => {
                    if (this.showAuthPopup) {
                        this.getRankingInfo()
                    }
                })
            }

            this.currentUser = currentUser()
            this.findOrderAbility()

            if (this.totalCoin > 0) {
                this.$store.dispatch('saveCoin', this.totalCoin).then(() => {
                    this.$store.dispatch('getCredit')
                })
            }
        },

        youVsWorldLogin() {
            this.joinMenu = false
            this.showAuthPopup = true
            this.isSeePosition = true
        },

        goDefaultPage(className) {
            if (this.embedToken) {
                if (className) {
                    document.querySelector(`.${className}`).setAttribute('href', '#')
                }
                window.open(this.quiz.url, '_blank')
            }
        },

        goFrontPage() {
            window.onbeforeunload = function () {}

            if (this.embedToken) {
                window.open('/', '_blank')
                return
            }

            window.location.href = '/'
        },

        getResult() {
            let time = 0
            let correct = 0

            this.userSelected.forEach(select => {
                time += select.timer

                if (select.is_correct) {
                    correct++
                }
            })

            this.percent = -1
            this.setPercent(correct)
            this.setCorrect(correct)
            this.setTime(time)
            this.saveQuizResult(time, correct)
        },

        setTime(time) {
            this.timeSec = time

            let minute = Math.floor(time / 60)
            let second = time - minute * 60
            let timeStr = ''

            if (minute >= 1) {
                timeStr = `${minute}:${helper.numpad(second)}`
            } else {
                timeStr = `0:${helper.numpad(second)}`
            }

            this.time = timeStr
        },

        setPercent(correct) {
            let percent = this.getPercent(correct)
            this.percent = percent

            if (currentUser()) {
                var payload = {
                    score: percent,
                    tags: this.tags,
                    user_id: currentUser().id,
                    auto_update: true
                }

                this.$store.dispatch('findCategoryScore', payload).then(async res => {
                    if (res.data.status_code == 200) {
                        await Array(...res.data.data).map(item => {
                            this.overAllScore =
                                res.data.data
                                    .map(i => i.score_average)
                                    .reduce(function (acc, val) {
                                        return acc + val
                                    }, 0) / res.data.data.length
                            this.overAllIsUp =
                                res.data.data
                                    .map(i => i.score_average)
                                    .reduce(function (acc, val) {
                                        return acc + val
                                    }, 0) /
                                    res.data.data.length >
                                res.data.data
                                    .map(i => i.previous_average)
                                    .reduce(function (acc, val) {
                                        return acc + val
                                    }, 0) /
                                    res.data.data.length
                            this.yourProgress.push({
                                title: item.category.name,
                                category_id: item.category_id,
                                percent: item.score_average,
                                isUp: item.is_up,
                                isDown: item.is_down
                            })
                        })
                    }
                })
            }
        },

        getPercent(correct) {
            let percent = (correct * 100) / this.questionCount

            if (percent >= 100) {
                percent = 100
            }

            return percent
        },

        setCorrect(correct) {
            this.correct = `${correct}/${this.questionCount}`
        },

        restartAgain() {
            if (this.embedToken) {
                this.goDefaultPage()
                return
            }

            this.hideConfirmLeavePage()
            let extraQueries = {}

            if (this.playAloneReportToken) {
                extraQueries['rp'] = this.playAloneReportToken
            }

            if (this.isFromMyQuiz) {
                extraQueries['ref'] = 'myquiz'
            }

            extraQueries = new URLSearchParams(extraQueries).toString()

            window.location.href = `/play/${this.$route.params.code}/start${extraQueries ? '?' + extraQueries : ''}`
        },

        playAgain() {
            if (!this.wrongQuestions.length) {
                return
            }

            this.$store.commit('player/updateCurrentQuizIndex', 0)
            this.$store.commit('player/updateManyQuestion', this.wrongQuestions)
            this.$store.commit('player/clearWrongQuestion')
            this.$store.commit('player/clearUserAnswer')
            this.$store.commit('player/clearCoin')

            this.$router.push({
                name: 'play-alone-retry',
                params: {
                    code: this.$route.params.code
                }
            })
        },

        closeDidYouLearn() {
            this.showDidyouLearnPopup = false
        },

        takeAnother() {
            this.hideConfirmLeavePage()
            window.location.href = '/'
        },

        openShare() {
            let percent = parseFloat(String(this.percent).replace(/[,]/g, '.')).toFixed(1)
            var payload = {
                score: percent,
                quiz: this.quizId
            }

            if (window.navigator.share) {
                navigator.share({
                    title: `I got ${percent}% correct on ${this.title}. Can you beat me?`,
                    text: this.description,
                    url: encodeURI(`${appConfig.baseUrl}user/share/quiz?data=${btoa(JSON.stringify(payload))}`)
                })
            } else {
                this.shareListOpen = !this.shareListOpen
            }
        },

        copyShareLink() {
            let url = `${appConfig.baseUrl}quiz/${this.code}/share`
            // If browser support native share link
            if (window.navigator.share) {
                navigator
                    .share({
                        title: 'TheBigQuiz',
                        text: `Join ${this.title} - TheBigQuiz`,
                        url: url
                    })
                    .then(() => {})
            } else {
                navigator.clipboard
                    .writeText(url)
                    .then(() => {
                        popup.alert(this.$t('playalone_summary_share_alert_link_copied'), () => {}, {
                            icon: 'success'
                        })
                    })
                    .catch(() => {
                        popup.alert(this.$t('playalone_summary_share_alert_link_copied_error'), () => {}, {
                            icon: 'error'
                        })
                    })
            }
        },

        saveQuizResult(time, correct) {
            var request = new Request()
            var percent = this.getPercent(correct)
            var formData = {
                playing_time: time,
                score: percent
            }

            formData = crypto.enc(JSON.stringify(formData))

            var url = appConfig.api.saveQuizResult.replace('__id__', this.quizId)
            var self = this

            request
                .post(url, formData)
                .then(function (res) {
                    let amount = res.data.data.amount
                    let avg = res.data.data.average_percent

                    self.avgScore = Math.floor(parseFloat(avg))
                    self.amongTop = Math.floor(parseFloat(amount))
                })
                .catch(function (err) {
                    var errorMessage = err.response.data.message

                    self.$store.commit('updateMainModalMessage', errorMessage)
                    self.$store.commit('toggleMainModal', true)
                })
        },

        setConfirmLeavePage() {
            window.onbeforeunload = function () {
                return 'Are you sure you want to leave this page? You will loose any unsaved actions'
            }
        },

        hideConfirmLeavePage() {
            window.onbeforeunload = function () {}
        },

        resizeScaleQuizFrame() {
            const contentElem = document.getElementsByClassName('content-container')[0]
            const layoutElem = document.getElementsByClassName('layout')[0]
            const headerElem = document.getElementsByClassName('header')[0]
            const footerElem = document.getElementsByClassName('footer')[0]
            const footerHeight = footerElem.getBoundingClientRect().height
            const headerHeight = headerElem.getBoundingClientRect().height
            const uselessHeight = headerHeight + footerHeight

            layoutElem.style.setProperty('--useless-h', `${uselessHeight}px`)

            new ResizeScale({
                width: contentElem.getBoundingClientRect().width,
                height: contentElem.getBoundingClientRect().height,
                child: contentElem,
                parent: layoutElem,
                uselessHeight: uselessHeight + 50,
                headerHeight: headerHeight,
                footerHeight: footerHeight,
                onlyDestop: true
            })

            document.getElementById('app').classList.add('overflow-hidden')
            document.getElementById('app').classList.add('relative')

            this.isAlreadyShow = true

            if (!isLoggedIn()) {
                this.isAnimateAfterCoinEnd = true
            }
        },

        showCoinAnimation() {
            if (this.totalCoin <= 0) {
                if (this.quiz.is_sponsor_quiz) {
                    this.showSponsorPopup()
                }
                return false
            }

            this.isShowCoinContainer = true
        },

        findOrderAbility() {
            this.$store.dispatch('findOrderAbility')
        },

        paymentSuccess(payload) {
            this.findOrderAbility()
            this.trackPay(payload.method, `Pay_${this.code}_single`)
        },

        gotoPurchasePage() {
            window.location.href = this.$router.resolve({
                name: 'purchase'
            }).href
        },

        onShowDidYouLearn() {
            if (this.embedToken) {
                this.goDefaultPage()
                return
            }

            if (this.orderAbility.is_24hrs_access) {
                this.showDidyouLearnPopup = true
                return
            }

            this.showPaymentPopup = true
        },

        onShowYourProgress() {
            if (this.embedToken) {
                this.goDefaultPage()
                return
            }

            if (this.orderAbility.has_subscribed || this.orderAbility.is_24hrs_access) {
                this.showYourProgressPopup = true
                return
            }

            this.showPaymentPopup = true
        },

        onCoinAnimateEnded() {
            this.isShowCoinContainer = false
            this.isAnimateAfterCoinEnd = true
        },

        onSelectImprove(progress) {
            this.showImprovePopup = true
            this.improveSelected = progress
        },

        onClickRandomQuiz(category) {
            const url =
                appConfig.baseUrl.slice(0, appConfig.baseUrl.lastIndexOf('/')) +
                '/random-quiz/category/' +
                category.toLowerCase()
            window.location.href = url
        },

        onClickSpecific(category) {
            const url =
                appConfig.baseUrl.slice(0, appConfig.baseUrl.lastIndexOf('/')) + '/category/' + category.toLowerCase()
            window.location.href = url
        },

        createWebviewRedirectTo() {
            var title = helper.slugify(this.quiz.title)
            return `/quiz/${this.quiz.code}/${title}`
        },

        onClickQuiz(e, url) {
            this.hideConfirmLeavePage()
            if (this.embedToken) {
                window.open(url, '_blank')
            } else {
                window.location.href = url
            }
        },

        clickLogout() {
            this.hideConfirmLeavePage()
        },

        saveSponsorQuizScore() {
            if (!isLoggedIn()) {
                return false
            }

            if (!this.quiz.is_sponsor_quiz) {
                return false
            }

            const refCookieKey = 'sponsor-quiz-token-ref'
            const refToken = Cookies.get(refCookieKey)

            let payload = {
                quiz_id: this.quiz._id.$oid,
                user_id: currentUser().id,
                score: parseFloat(this.percent).toFixed(2),
                time: this.timeSec,
                ref_token: refToken
            }

            payload = crypto.enc(JSON.stringify(payload))

            if (refToken) {
                Cookies.remove(refCookieKey)
            }

            return this.$store.dispatch('player/saveSponsorQuizScore', payload)
        },

        saveSponsorQuizTrack(key) {
            const payload = {
                quiz_id: this.quiz._id.$oid,
                key: `${key}_click_count`
            }

            if (key == 'video') {
                this.$refs.muteBtn.onSponsorVideo()
            }

            this.$store.dispatch('player/sponsorQuizTrack', payload)
        },

        async updateUserInfoInRanking(payload) {
            await this.$store.dispatch('player/updateUserInfoInRanking', {
                quiz_id: this.quiz._id.$oid,
                user_id: currentUser().id,
                key: payload.key,
                value: payload.value
            })
            this.$refs.authPopup.setLoader(false)
        },

        setInfoRanking(info) {
            if (this.embedToken) {
                return
            }

            this.$nextTick(() => {
                if (this.$refs.authPopup) {
                    this.$refs.authPopup.setUserContactData(info)
                }
            })
        },

        getRankingInfo() {
            if (!isLoggedIn()) {
                return false
            }

            this.$store
                .dispatch('player/getRankingInfo', { id: this.quiz._id.$oid, userId: currentUser().id })
                .then(res => {
                    const info = res.data.data
                    this.setInfoRanking(info)
                })
        },

        onClickJoinCompetition() {
            this.$store.commit('toggleMainLoader', true)
            this.showAuthPopup = true
            this.joinMenu = true

            if (!isLoggedIn()) {
                this.$store.commit('toggleMainLoader', false)
                return false
            }

            this.$store
                .dispatch('player/getRankingInfo', { id: this.quiz._id.$oid, userId: currentUser().id })
                .then(res => {
                    const info = res.data.data
                    this.setInfoRanking(info)
                    this.$store.commit('toggleMainLoader', false)
                })
                .catch(() => {
                    this.$store.commit('toggleMainLoader', false)
                })
        },

        showSponsorPopup() {
            this.isRewardAnimation = true

            if (isLoggedIn()) {
                this.createShareLink()
            }

            setTimeout(() => {
                if (this.quiz.is_sponsor_quiz) {
                    this.joinMenu = true
                    this.showAuthPopup = true
                    this.getRankingInfo()
                }
            }, 1000)
        },

        createShareLink() {
            this.$store
                .dispatch('createSponsorQuizShareLink', {
                    quiz_id: this.quiz._id.$oid
                })
                .then(res => {
                    this.shareLinkUrl = res.data.data.url
                })
        },

        getNotLoggedInUser() {
            const user = window.localStorage.getItem('playalone-anonymous-user')

            if (!user) {
                return false
            }

            try {
                return JSON.parse(user)
            } catch {
                return false
            }
        },

        saveForReport() {
            if (!this.playAloneReportToken) {
                return
            }

            if (!currentUser() && this.getNotLoggedInUser()) {
                const user = this.getNotLoggedInUser()

                this.$store.dispatch('player/saveNotLoggedInPlayAloneReport', {
                    quiz_id: this.quizId,
                    user: {
                        name: user.name,
                        email: user.email,
                        agree: user.agree
                    },
                    token: this.playAloneReportToken,
                    result: this.userSelected
                })

                return
            }

            this.$store.dispatch('player/savePlayAloneReport', {
                quiz_id: this.quizId,
                user_id: currentUser().id,
                token: this.playAloneReportToken,
                result: this.userSelected
            })
        },

        quizRelateInViewport() {
            let options = {
                threshold: 0.1
            }

            let observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.isArrowRelate = false
                    } else {
                        this.isArrowRelate = true
                    }
                })
            }, options)

            const quizRelate = document.querySelector('#quiz-relate')
            if (quizRelate) {
                observer.observe(quizRelate)
            }
        },

        scrollToBottom() {
            const content = document.querySelector('.content')
            content.scrollTo({ top: content.scrollHeight, behavior: 'smooth' })
        }
    },

    beforeRouteLeave(to, from, next) {
        let self = this

        self.hideConfirmLeavePage()

        if (to.name === 'play-alone' || to.name === 'play-alone-result' || to.name === 'play-alone-start') {
            next(false)
            popup.confirm(
                this.$t('playalone_alert_leave'),
                function () {
                    window.location.href = '/'
                },
                function () {
                    self.setConfirmLeavePage()
                }
            )
        }

        if (to.name == 'play-alone-retry' || to.name === 'edit') {
            document.querySelector('.app-wrapper').style.overflowY = 'auto'
            next()
        }
    }
}
</script>

<style lang="scss">
body.has-bg-image::before {
    content: '';
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: -1;
    pointer-events: none;
}

.logo {
    @media (min-width: 767px) {
        width: 12rem;
    }
}

.title-header {
    display: none;
    position: absolute;
    top: 9px;
    left: 8px;
    text-decoration: unset;
}

.quiz-description {
    a {
        color: #fff;
    }
}

.layout {
    height: calc(100vh - 2rem) !important;
    height: calc((var(--vh, 1vh) * 100) - 2rem) !important;

    &.no-footer {
        height: calc((var(--vh, 1vh) * 100)) !important;
        padding-bottom: 0 !important;
    }
}

.btn {
    text-shadow: unset !important;
    text-transform: unset;

    &.font-normal {
        font-weight: 400;
    }
}

.btn-white {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
    background-color: #fff;
    color: #000;

    &:hover {
        background-color: #fff;
        filter: contrast(0.75);
    }
}

@media (max-width: 500px) {
    .logo {
        pointer-events: none;
        visibility: hidden;

        > .mask {
            visibility: hidden;
        }
    }

    .bg-item {
        display: none;
    }

    .title-box {
        display: none;
    }

    .title-header {
        display: block;
    }
}

.dropdown.dropup {
    .btn {
        padding-right: 1.15rem;
        padding-left: 1.15rem;
    }

    .dropdown-menu {
        transform: scale(0);
        transform-origin: 10% 100%;
        position: absolute;
        padding: 0;
        margin-top: -7.5em;
        height: fit-content;
        transition: transform 0.5s;

        &.show {
            transform: scale(1);
            padding: 0.25rem 0;
        }

        .dropdown-item {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-align: left;
            text-transform: uppercase;
            border-radius: 8px;
            color: #000;
            background-color: #fff;
            padding: 0.5rem 1.5rem;
            margin-bottom: 0.5rem;
            border-radius: 0.5rem;
            text-shadow: unset !important;

            &:hover {
                transform: scale(1.05);
            }
        }
    }
}

section.layout .footer {
    padding: 0 1rem;
    position: absolute;
    right: 0;
    bottom: 1rem;
    width: 100%;
}

.progress-btn:hover {
    text-decoration: underline;
    filter: drop-shadow(2px 4px 6px var(--question-shadow-color));
}

.app-wrapper,
section.layout .content {
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
}

.app-wrapper {
    overflow-y: hidden;
}

.app-wrapper::-webkit-scrollbar {
    display: none;
}

.relate {
    overflow: hidden;
    max-height: 0;
    margin-top: 2.5rem;

    &.open {
        max-height: unset;
    }
}

.mute-btn {
    top: 30px !important;
    right: 70px !important;
}

.not-logIn {
    top: 21px !important;
}

@media screen and (max-width: 768px) {
    section.layout .content {
        overflow-y: auto;
        overflow-x: hidden;
    }
}

@media screen and (max-width: 768px) {
    section.layout .content {
        height: calc(100% - var(--useless-h));
    }

    section.layout .footer {
        bottom: 0;
    }

    .btn-large {
        padding: 0.6rem 0;
        width: 100%;
    }

    .mute-btn {
        top: 21px !important;
        right: 64px !important;
    }

    .not-logIn {
        top: 11px !important;
    }
}

@media screen and (max-width: 575px) {
    .btn-large {
        font-size: 15px;
    }

    .summary-right-menu {
        .right-menu {
            top: 10px;
            right: 10px;
        }
    }

    .mute-btn {
        top: 16px !important;
        right: 54px !important;
    }

    .not-logIn {
        top: 15px !important;
    }
}

@media screen and (max-width: 350px) {
    .btn {
        padding: 0.5rem 1.5rem;
    }

    .btn-large {
        font-size: 10px;
    }
}
</style>
